import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../fragments'

const LATEST_EVENT_BY_ENTITY_TYPES_QUERY = gql`
  query latestEventByEntityTypes($entityTypes: [EventEntityType!]!) {
    latestEventByEntityTypes(entityTypes: $entityTypes) {
      ...EventFragment
    }
  }
  ${EVENT_FRAGMENT}
`

export default LATEST_EVENT_BY_ENTITY_TYPES_QUERY
